<div class="info-card mb-4">
  <div class="card-header">
    <span class="card-title mb-0"> Policy Drilldown </span>
  </div>

  <div class="card-info">
    <!-- Drilldown breadcrumb: every level shows a "grouped by" pill; deeper levels prepend a reset button and scoped pills. -->
    <div class="drilldown-crumb-info">
      <div class="drilldown-trail">
        <button
          type="button"
          class="trail-pill trail-pill-reset"
          [disabled]="drilldownCrumbs.length === 0"
          (click)="resetDrilldown(true)"
        >
          <mat-icon class="trail-pill-icon">replay</mat-icon>
          Reset
        </button>
        @if (drilldownCrumbs.length === 0) {
          <mat-icon class="trail-arrow">chevron_right</mat-icon>
        }
        @if (drilldownCrumbs.length > 0) {
          @for (crumb of drilldownCrumbs; track $index) {
            <mat-icon class="trail-arrow">chevron_right</mat-icon>
            <!-- Ancestor pill: returns to that grouping level, trimming deeper scope. -->
            <button
              type="button"
              class="trail-pill trail-pill-link"
              [matTooltip]="'Go back to ' + crumb.levelLabel"
              (click)="goToCrumb(crumb.level)"
            >
              {{ crumb.label }}
            </button>
          }
          <mat-icon class="trail-arrow">chevron_right</mat-icon>
        }
        <!-- Current grouping label, always shown (including the top level). -->
        <span class="trail-pill trail-pill-current">
          Grouped by: {{ currentLevelLabel }}
        </span>
      </div>
      @if (canEmitFilters()) {
        <div>
          <button
            type="button"
            matButton
            [matTooltip]="'Filter other widgets to match this drilldown'"
            (click)="emitFilters($event)"
          >
            Apply to page
          </button>
        </div>
      }
    </div>

    <kendo-grid
      #usageGrid="kendoGrid"
      class="w-100"
      [data]="gridData"
      [pageable]="true"
      [skip]="skip * 1"
      [pageSize]="take"
      [columnMenu]="{ columnChooser: false }"
      [height]="400"
      [size]="'small'"
      (dataStateChange)="dataStateChange($event)"
    >
      @for (header of gridData.headers; track $index) {
        <!-- First column flexes to fill remaining space; all others use a fixed width so the current group extends left on drilldown. -->
        <kendo-grid-column
          [field]="header.DataField"
          [title]="header.Label"
          [sortable]="header.Sort"
          [filterable]="header.Filter"
          [width]="$index === 0 ? undefined : 180"
        >
          <ng-template let-dataItem kendoGridCellTemplate>
            @if (header.DataField === 'policy') {
              @if ($index !== 0) {
                @if (view === 'carrier') {
                  <button
                    type="button"
                    matButton
                    matTooltip="Launch to Policy Details"
                    (click)="
                      handleItemClick(dataItem, 'carrier-policy-details')
                    "
                  >
                    <span class="button-info-container">
                      @if (dataItem.NPN) {
                        <mat-icon class="me-2">launch</mat-icon>
                        {{ dataItem[header.DataField] }}
                      } @else {
                        <mat-icon class="me-2">launch</mat-icon>
                        {{ formatNumber(dataItem[header.DataField]) }}
                      }
                    </span>
                  </button>
                } @else {
                  <button
                    type="button"
                    matButton
                    matTooltip="Launch to Book Management"
                    (click)="handleItemClick(dataItem, 'book-management')"
                  >
                    <span class="button-info-container">
                      @if (dataItem.NPN) {
                        <mat-icon class="me-2">launch</mat-icon>
                        {{ dataItem[header.DataField] }}
                      } @else {
                        <mat-icon class="me-2">launch</mat-icon>
                        {{ formatNumber(dataItem[header.DataField]) }}
                      }
                    </span>
                  </button>
                }
              } @else {
                {{ dataItem[header.DataField] }}
              }
            } @else if (header.DataField !== 'policy') {
              <span class="cell-with-drill">
                @if (
                  header.DataField === 'producer' &&
                  dataItem.NPN &&
                  canLaunchToRepView
                ) {
                  {{ dataItem[header.DataField] }}

                  <button
                    type="button"
                    matButton
                    matTooltip="Launch and Filter in Rep View"
                    (click)="
                      handleItemClick(dataItem, 'book-management/rep-reports')
                    "
                  >
                    <mat-icon>launch</mat-icon>{{ dataItem['NPN'] }}
                  </button>
                } @else {
                  @if ($index !== 0) {
                    {{ formatNumber(dataItem[header.DataField]) }}
                  } @else {
                    {{ dataItem[header.DataField] }}
                  }
                }
                @if (canDrilldown(header.DataField)) {
                  <button
                    type="button"
                    mat-icon-button
                    class="drilldown-arrow"
                    [matTooltip]="'Drill down by ' + header.Label"
                    (click)="drilldown(header.DataField, dataItem)"
                  >
                    <mat-icon>subdirectory_arrow_right</mat-icon>
                  </button>
                }
              </span>
            }
          </ng-template>
          <!-- if item is producer, add the launch to rep view button
          if the item is policies, add the launch to bm button -->
        </kendo-grid-column>
      }
      <ng-template
        let-totalPages="totalPages"
        let-currentPage="currentPage"
        kendoPagerTemplate
      >
        <kendo-pager-prev-buttons />
        <kendo-pager-numeric-buttons [buttonCount]="5" />
        <kendo-pager-next-buttons />
        <kendo-pager-input />
        <kendo-pager-info />
        <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
      </ng-template>
    </kendo-grid>
    <ngx-loading
      [show]="loading$ | async"
      [config]="{
        fullScreenBackdrop: false,
      }" /></div
></div>
